var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 -1 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m17.584 7.062.074.092 1.71 2.43a1 1 0 0 1-1.558 1.25l-.078-.099-.328-.465c-.983 3.154-3.95 5.48-7.405 5.48-2.632 0-5.038-1.302-6.418-3.425a1 1 0 0 1 1.677-1.09c1.01 1.554 2.785 2.515 4.741 2.515 2.409 0 4.508-1.539 5.353-3.673l-.347.257a1 1 0 0 1-1.287-1.527l.096-.08 2.43-1.8a1 1 0 0 1 1.34.135ZM10 .25c2.754 0 5.256 1.422 6.62 3.731A1 1 0 1 1 14.9 5c-1.004-1.7-2.85-2.749-4.9-2.749-2.47 0-4.598 1.54-5.384 3.773l.4-.28a1 1 0 0 1 1.248 1.556l-.098.079-2.43 1.71a1 1 0 0 1-1.33-.163l-.073-.093-1.71-2.52a1 1 0 0 1 1.584-1.216l.071.092.342.505C3.583 2.49 6.549.25 9.999.25Z"
  })));
};
export default SvgRefresh;